import { mdiClockTimeFourOutline, mdiPiggyBankOutline } from "@mdi/js";
import Icon from "@mdi/react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";

import { ReactComponent as LetterLogo } from "assets/letter-logo.svg";
import Button from "components/Button";
import { NumericZeroSVGIcon } from "components/SVGIcons";
import { LOAD_INTRODUCTION } from "constants/link";
import { routes } from "constants/routes";
import { useUserFeature } from "hooks/useUserFeature";
import styles from "./style.module.scss";

export default function NoneFactoringStatus() {
  const navigate = useNavigate();
  const { isBroker } = useUserFeature();

  const goToJoinHaulPay = () => {
    navigate(routes.HAULPAY_JOIN);
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.loadPostTitle}>
        <LetterLogo className={styles.loadPostLetterLogo} />
        <span className={styles.loadPostSubTitle}>Digital Freight Finance & Load Tech</span>
      </div>
      {isBroker ? (
        <p>Get free load board access and more when you use us fo Factoring or Carrier Payments.</p>
      ) : (
        <p>Get full access to out Load Board for free when you join Haul Pay</p>
      )}

      <Button className={styles.joinHaulPayButton} onClick={goToJoinHaulPay}>
        Apply Today
      </Button>
      <ReactPlayer url={LOAD_INTRODUCTION} playing={false} controls={true} width="100%" />

      {isBroker ? (
        <p>
          HaulPay enables you to pay carriers as fast as the same day using our financing or your
          own.
        </p>
      ) : (
        <p>HaulPay enables you to pay carriers as fast as the same day with unlimited capital!</p>
      )}

      <div className={styles.cardGroup}>
        <div className={styles.loadPostCard}>
          <div className={styles.loadPostCardIcon}>
            <Icon path={mdiPiggyBankOutline} className="size-14 text-success" />
          </div>
          <div className={styles.loadPostCardContents}>
            <h3 className="text-4xl font-bold">LOW</h3>
            <h4 className="font-medium leading-6">Flat Tate Per Load</h4>
            <ul className={styles.loadPostCardList}>
              <li>No long-term contracts</li>
              <li>No early termination fees</li>
            </ul>
          </div>
        </div>

        <div className={styles.loadPostCard}>
          <div className={styles.loadPostCardIcon}>
            <Icon path={mdiClockTimeFourOutline} className="size-14 text-success" />
          </div>
          <div className={styles.loadPostCardContents}>
            <h3 className="text-4xl font-bold">24 Hrs.</h3>
            <h4 className="font-medium leading-6">Carrier Pay</h4>
            <ul className={styles.loadPostCardList}>
              <li>Available same day pey</li>
              <li>Easy payment requests</li>
            </ul>
          </div>
        </div>

        <div className={styles.loadPostCard}>
          <div className={styles.loadPostCardIcon}>
            <NumericZeroSVGIcon className="size-20 -m-3.5 text-success" />
          </div>
          <div className={styles.loadPostCardContents}>
            <h3 className="text-4xl font-bold">Zero</h3>
            <h4 className="font-medium leading-6">Extra Fees</h4>
            <ul className={styles.loadPostCardList}>
              <li>No account minimums</li>
              <li>Free booking mobile app</li>
            </ul>
          </div>
        </div>
      </div>

      <Button className={styles.joinHaulPayButton} onClick={goToJoinHaulPay}>
        Apply Today
      </Button>
      <p>
        You can pass the quick pay fee off to the carrier or choose to offset it to your shipper
        making the program free!
      </p>
    </div>
  );
}
